module.exports = __webpack_public_path__ + "img/apres3.3f9af8d1.png";